import * as React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as PaidIcon,
  HourglassEmpty as PendingIcon,
  Link as CreatedIcon,
  Cancel as CancelledIcon,
  Error as ErrorIcon,
  LocalShipping as DeliveryIcon,
  TimerOff as ExpiredIcon,
} from '@mui/icons-material';

const statusConfig = {
  created: {
    color: '#1e40af',
    bgcolor: '#dbeafe',
    borderColor: '#93c5fd',
    icon: CreatedIcon,
  },
  pending: {
    color: '#92400e',
    bgcolor: '#fef3c7',
    borderColor: '#fcd34d',
    icon: PendingIcon,
  },
  paid: {
    color: '#065f46',
    bgcolor: '#d1fae5',
    borderColor: '#6ee7b7',
    icon: PaidIcon,
  },
  delivery_required: {
    color: '#9a3412',
    bgcolor: '#ffedd5',
    borderColor: '#fdba74',
    icon: DeliveryIcon,
  },
  settled: {
    color: '#065f46',
    bgcolor: '#d1fae5',
    borderColor: '#6ee7b7',
    icon: PaidIcon,
  },
  cancelled: {
    color: '#4b5563',
    bgcolor: '#f3f4f6',
    borderColor: '#d1d5db',
    icon: CancelledIcon,
  },
  error: {
    color: '#991b1b',
    bgcolor: '#fee2e2',
    borderColor: '#fca5a5',
    icon: ErrorIcon,
  },
  denied: {
    color: '#991b1b',
    bgcolor: '#fee2e2',
    borderColor: '#fca5a5',
    icon: CancelledIcon,
  },
  refunded: {
    color: '#9a3412',
    bgcolor: '#ffedd5',
    borderColor: '#fdba74',
    icon: CancelledIcon,
  },
  expired: {
    color: '#4b5563',
    bgcolor: '#f3f4f6',
    borderColor: '#d1d5db',
    icon: ExpiredIcon,
  },
};

/**
 * Status chip shared by every financing provider (Svea, Resurs). The provider passes the
 * translated label; colour and icon come from the status.
 */
const FinancingStatusBadge = ({ status, label, size = 'small', ...rest }) => {
  if (!status) {
    return null;
  }

  const config = statusConfig[status] || statusConfig.pending;
  const IconComponent = config.icon;

  return (
    <Chip
      label={label || status}
      size={size}
      icon={<IconComponent sx={{ fontSize: size === 'small' ? '14px' : '16px' }} />}
      sx={{
        color: config.color,
        bgcolor: config.bgcolor,
        border: `1px solid ${config.borderColor}`,
        fontWeight: 500,
        fontSize: size === 'small' ? '11px' : '12px',
        height: size === 'small' ? '22px' : '26px',
        '& .MuiChip-label': {
          px: 0.75,
        },
        '& .MuiChip-icon': {
          color: config.color,
          marginLeft: '6px',
        },
      }}
      {...rest}
    />
  );
};

export default FinancingStatusBadge;
